(() => {
  const dialog = document.getElementById('tg-description-zoom');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const closeButton = dialog.querySelector('button');
  let previousFocus, previousOverflow;
  const imageURL = url => /\.(?:jpe?g|png|webp|gif|avif)(?:[?#]|$)/i.test(url || '');
  function close() { if (dialog.open) dialog.close(); }
  function open(src, alt, trigger) {
    previousFocus = trigger;
    image.src = src;
    image.alt = alt || dialog.dataset.imageLabel;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    closeButton.focus();
  }
  function activate(event) {
    if (!(event.target instanceof Element)) return;
    const details = event.target.closest('.product-details');
    if (!details || event.target.closest('form,button')) return;
    const anchor = event.target.closest('a[href]');
    const img = event.target.closest('img');
    let src, alt;
    if (anchor && imageURL(anchor.href) && (anchor.querySelector('img') || anchor.closest('.tg-certificate,.tg-product-certificate'))) {
      src = anchor.href;
      alt = anchor.querySelector('img')?.alt || dialog.dataset.imageLabel;
    } else if (img) {
      src = img.currentSrc || img.src;
      alt = img.alt;
    }
    if (!src) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(src, alt, anchor || img);
  }
  document.addEventListener('click', activate, true);
  document.addEventListener('keydown', event => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof HTMLImageElement && event.target.closest('.product-details')) activate(event);
  });
  document.querySelectorAll('.product-details img').forEach(img => {
    if (!img.closest('a,button,form')) {
      img.tabIndex = 0;
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', dialog.dataset.imageLabel);
    }
    img.style.cursor = 'zoom-in';
  });
  closeButton.addEventListener('click', close);
  dialog.addEventListener('click', event => { if (event.target === dialog || event.target === image) close(); });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    previousFocus?.focus({preventScroll:true});
  });
})();